export default ({vehicle: {plate = ''} = {}} = {}) => plate;
